import type { SignalAmplitudeRule } from './helpers';

export const signalAmplitudeRules: Record<string, SignalAmplitudeRule> = {
  // EEG — initial = absolute (from table: -35 … 35 µV)
  EEG_frontal_L: {
    min: -35,
    max: 35,
    absoluteMin: -732,
    absoluteMax: 732,
    step: 15,
    symmetric: true,
    unit: 'µV'
  },
  EEG_frontal_R: {
    min: -35,
    max: 35,
    absoluteMin: -732,
    absoluteMax: 732,
    step: 15,
    symmetric: true,
    unit: 'µV'
  },

  // EOG — -35 … 35 µV
  EOG_L: {
    min: -35,
    max: 35,
    absoluteMin: -1465,
    absoluteMax: 1465,
    step: 15,
    symmetric: true,
    unit: 'µV'
  },
  EOG_R: {
    min: -35,
    max: 35,
    absoluteMin: -1465,
    absoluteMax: 1465,
    step: 15,
    symmetric: true,
    unit: 'µV'
  },

  // EMG — -25 … 25 µV
  EMG_mass_L: {
    min: -25,
    max: 25,
    absoluteMin: -732,
    absoluteMax: 732,
    step: 10,
    symmetric: true,
    unit: 'µV'
  },
  EMG_mass_R: {
    min: -25,
    max: 25,
    absoluteMin: -732,
    absoluteMax: 732,
    step: 10,
    symmetric: true,
    unit: 'µV'
  },

  // ECG — -1 … 1 mV (step 0.5 mV)
  ECG: {
    min: -1,
    max: 1,
    absoluteMin: -50,
    absoluteMax: 50,
    step: 0.5, // 500 µV
    symmetric: true,
    unit: 'mV'
  },

  // Heart Rate — 40 … 80 bpm
  Heart_rate: {
    min: 40,
    max: 80,
    absoluteMin: 30,
    absoluteMax: 150,
    step: 10,
    symmetric: true,
    unit: 'bpm'
  },

  // Nasal Pressure — auto-based
  Nasal_pressure: {
    min: 'auto',
    max: 'auto',
    absoluteMin: -295,
    absoluteMax: 190,
    step: 0.2,
    symmetric: true,
    unit: ''
  },

  // Resp Flow — -1 … 1
  Resp_flow: {
    min: -1,
    max: 1,
    absoluteMin: -2,
    absoluteMax: 2,
    step: 0.1,
    symmetric: true,
    unit: ''
  },

  // Resp Effort — 0 … 1
  Resp_effort: {
    min: 0,
    max: 1,
    absoluteMin: -1,
    absoluteMax: 2,
    step: 0.05,
    symmetric: true,
    unit: ''
  },

  // SpO2 — 80% … 100%, asymmetric
  SpO2: {
    min: 80,
    max: 100,
    absoluteMin: 0,
    absoluteMax: 100,
    step: 10,
    symmetric: false,
    unit: '%'
  },

  // Sound — 35 … 80 dB
  Sound_SPL: {
    min: 20,
    max: 80,
    absoluteMin: -10,
    absoluteMax: 120,
    step: 5,
    symmetric: false,
    unit: 'dB'
  },

  // EMG Leg — -150 … 150 µV
  EMG_leg: {
    min: -25,
    max: 25,
    absoluteMin: -50000,
    absoluteMax: 50000,
    step: 5,
    symmetric: true,
    unit: 'µV'
  },

  // Activity — 0 … 0.5 g (asymmetric)
  Activity: {
    min: 0,
    max: 0.5,
    absoluteMin: -1,
    absoluteMax: 8,
    step: 0.05,
    symmetric: false,
    unit: 'g'
  }
};
